import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'

import {
  StyledDialog,
  StyledDialogActions,
  StyledButtonLeft,
  StyledButtonRight,
} from './Styled'
import _ from 'lodash'
import { closeDialog } from '../../redux/slices/alertDialog'

import ContentDialog from './Content'
import ErrorDetail from './ErrorDetail'

const Index = () => {
  const dialog = useSelector((state) => state.alertDialog)
  const {
    type,
    isOpen,
    isLoading,
    content,
    maxWidth,
    customWidth,
    disableButton,
    handleCancel,
    isCloseDialog,
    fullWidth,
    buttonLeft,
    buttonRight,
    buttonCenter,
    isHiddenFooter,
    zIndex = 1299,
    px,
    // isHiddenButton,
  } = dialog

  const dispatch = useDispatch()
  return (
    <Box>
      <StyledDialog
        customWidth={customWidth}
        fullWidth={fullWidth}
        maxWidth={maxWidth ?? 'sm'}
        open={isOpen}
        onClose={() => {
          if (isCloseDialog && isOpen) {
            handleCancel && handleCancel()
            dispatch(closeDialog())
          }
        }}
        sx={{ zIndex: `${zIndex} !important` }}
      >
        {type == 'default' ? (
          <Box>
            <ContentDialog />
            {window.__env__.ENV == 'DEV' && dialog.errorCurl && (
              <ErrorDetail curl={dialog.errorCurl} />
            )}
            {!isHiddenFooter && (
              <StyledDialogActions px={px}>
                {!isLoading && !_.isEmpty(buttonLeft) && (
                  <StyledButtonLeft
                    data-testid="btn-disagree"
                    size="l"
                    variant="outlined"
                    disabled={_.get(buttonLeft, 'disabled', false)}
                    sx={_.get(buttonLeft, 'style', { width: '100%' })}
                    onClick={_.get(buttonLeft, 'handleClick', () =>
                      dispatch(closeDialog())
                    )}
                    startIcon={_.get(buttonLeft, 'startIcon', null)}
                    endIcon={_.get(buttonLeft, 'endIcon', null)}
                  >
                    <Typography
                      variant="button"
                      color={_.get(buttonLeft, 'colorText', 'auto')}
                    >
                      {_.get(buttonLeft, 'label', 'ยกเลิก')}
                    </Typography>
                  </StyledButtonLeft>
                )}
                {!_.isEmpty(buttonCenter) && (
                  <StyledButtonLeft
                    data-testid="btn-disagree"
                    size="l"
                    variant={_.get(buttonRight, 'variant', 'outlined')}
                    color={_.get(buttonRight, 'color', 'secondary')}
                    disabled={_.get(buttonCenter, 'disabled', false)}
                    sx={_.get(buttonCenter, 'style', { width: '100%' })}
                    onClick={_.get(buttonCenter, 'handleClick', () =>
                      dispatch(closeDialog())
                    )}
                    startIcon={_.get(buttonCenter, 'startIcon', null)}
                    endIcon={_.get(buttonCenter, 'endIcon', null)}
                  >
                    <Typography
                      variant="button"
                      color={_.get(buttonCenter, 'colorText', 'auto')}
                    >
                      {_.get(buttonCenter, 'label', '')}
                    </Typography>
                  </StyledButtonLeft>
                )}
                <StyledButtonRight
                  data-testid="btn-agree"
                  size="l"
                  loading={isLoading}
                  disabled={disableButton}
                  variant={_.get(buttonRight, 'variant', 'contained')}
                  color={_.get(buttonRight, 'color', 'primary')}
                  sx={_.get(buttonRight, 'style', { width: '100%' })}
                  onClick={_.get(buttonRight, 'handleClick', () =>
                    dispatch(closeDialog())
                  )}
                  startIcon={_.get(buttonRight, 'startIcon', null)}
                  endIcon={_.get(buttonRight, 'endIcon', null)}
                >
                  <Typography
                    variant="button"
                    sx={{
                      color: !disableButton ? 'auto' : 'rgba(0, 0, 0, 0.26)',
                    }}
                    color={_.get(buttonRight, 'colorText', 'auto')}
                  >
                    {_.get(buttonRight, 'label', 'ตกลง')}
                  </Typography>
                </StyledButtonRight>
              </StyledDialogActions>
            )}
          </Box>
        ) : (
          content
        )}
      </StyledDialog>
    </Box>
  )
}

export default Index
